import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { paths } from '@config/paths';

interface UseConversationNavigationResult {
	/** The conversationId from the URL path, or undefined when on the list view. */
	conversationId: string | undefined;
	/** Navigate to a specific conversation's deep link. */
	openConversation: (conversationId: string) => void;
	/** Navigate back to the conversation list (no selection). */
	closeConversation: () => void;
}

export const useConversationNavigation = (): UseConversationNavigationResult => {
	const navigate = useNavigate();
	const { servicesProviderId, conversationId } = useParams<{
		servicesProviderId: string;
		conversationId?: string;
	}>();

	const openConversation = useCallback(
		(id: string): void => {
			navigate(paths.conversation.getHref(servicesProviderId ?? '', id));
		},
		[navigate, servicesProviderId],
	);

	const closeConversation = useCallback((): void => {
		navigate(paths.conversations.getHref(servicesProviderId ?? ''));
	}, [navigate, servicesProviderId]);

	return { conversationId, openConversation, closeConversation };
};
